/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LinkSalesforceOpportunityInput = {|
  projectId?: ?string,
  opportunityId?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type LinkSalesforceOpportunityMutationVariables = {|
  input: LinkSalesforceOpportunityInput
|};
export type LinkSalesforceOpportunityMutationResponse = {|
  +linkSalesforceOpportunity: ?{|
    +project: ?{|
      +salesforceOpportunity: ?string
    |}
  |}
|};
export type LinkSalesforceOpportunityMutation = {|
  variables: LinkSalesforceOpportunityMutationVariables,
  response: LinkSalesforceOpportunityMutationResponse,
|};
*/


/*
mutation LinkSalesforceOpportunityMutation(
  $input: LinkSalesforceOpportunityInput!
) {
  linkSalesforceOpportunity(input: $input) {
    project {
      salesforceOpportunity
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "LinkSalesforceOpportunityInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesforceOpportunity",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LinkSalesforceOpportunityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LinkSalesforceOpportunityPayload",
        "kind": "LinkedField",
        "name": "linkSalesforceOpportunity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LinkSalesforceOpportunityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LinkSalesforceOpportunityPayload",
        "kind": "LinkedField",
        "name": "linkSalesforceOpportunity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "LinkSalesforceOpportunityMutation",
    "operationKind": "mutation",
    "text": "mutation LinkSalesforceOpportunityMutation(\n  $input: LinkSalesforceOpportunityInput!\n) {\n  linkSalesforceOpportunity(input: $input) {\n    project {\n      salesforceOpportunity\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8e45860104730dfec27dbc937179d48a';

module.exports = node;
